import { createMemoryHistory, createRouter } from "vue-router";
import DashboardView from "../views/DashboardView.vue";

const routes = [
  { path: "/amb-cve-assistant", name: "dashboard", component: DashboardView },
  { path: "/amb-cve-assistant/", redirect: "/amb-cve-assistant" },
  { path: "/:pathMatch(.*)*", redirect: "/amb-cve-assistant" },
];

export function createAppRouter() {
  return createRouter({
    history: createMemoryHistory(),
    routes,
  });
}
